/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Backdrop,
  Box, Button, CircularProgress,
} from '@material-ui/core';
import Card from '@material-ui/core/Card';
import Modal from '@material-ui/core/Modal';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import Timeline from '@material-ui/lab/Timeline';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import PropTypes from 'prop-types';

import play from '../../assets/icons/bx_play-circle.png';
import time from '../../assets/icons/bx_time.png';
import courseLogo from '../../assets/icons/idea.png';
import koins from '../../assets/icons/kcoin.png';
import { GetCourseById, GetInscription } from '../../services/courses';

import ModalCourse from './ModalCourse';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: '12px',
    maxWidth: 330,
    minWidth: 330,
    minHeight: 524,
    maxHeight: 524,
    background: theme.palette.background.card,
    color: theme.palette.common.white,
    margin: theme.spacing(0, 7),
    padding: theme.spacing(4, 4),
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(0, 3, 0, 1),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(0, 7),
    },
  },
  statusCard: {
    maxWidth: '20%',
    textAlign: 'center',
    borderRadius: '8px',
    background: theme.palette.background.info,
    color: theme.palette.common.black,
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
  },
  info: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
  },
  infoItems: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  cardAction: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.background.secondary,
  },
  button: {
    paddingLeft: '18%',
    paddingRight: '18%',
    fontFamily: 'Raleway',
    borderRadius: '8px',
  },
  font: {
    fontFamily: 'Raleway',
    fontSize: '14px',
  },
  itemsTimeline: {
    fontFamily: 'Raleway',
    fontSize: '14px',
    fontWeight: '400',
    padding: theme.spacing(0, 2),
  },
  itemsTimeDot: {
    background: theme.palette.background.info,
    margin: 0,
  },
  fontTitle: {
    fontFamily: 'Raleway',
    fontSize: '24px',
    fontWeight: '700',
  },
  overrides: {
    marginBottom: theme.spacing(-2),
  },
  img: {
    marginRight: theme.spacing(1),
  },
  disableCard: {
    background: theme.palette.background.disabled,
    maxWidth: 330,
    minWidth: 330,
    minHeight: 524,
    maxHeight: 524,
    textAlign: 'center',
    fontFamily: 'Raleway',
    color: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
  },
  iconClose: {
    color: theme.palette.common.white,
    cursor: 'pointer',
  },
  backdrop: {
    zIndex: 100,
  },
  modal: {
    overflow: 'scroll',
  },
}));

const TimelineItemNew = withStyles({
  missingOppositeContent: {
    '&:before': {
      display: 'none',
    },
  },
})(TimelineItem);
function CourseCard({
  title,
  description,
  topics,
  kcoins,
  duration,
  lessons,
  id,
  shortDescription,
}) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [topicsByCourse, setTopicsByCourse] = useState([]);
  const arrayLength = topics.length;
  const listTopics = topics.sort((a, b) => a.createdAt - b.createdAt).map((e) => e.name);
  const { sub } = useSelector((store) => store.login);
  const cardDescription = `${shortDescription.slice(0, 175)}...`;
  const topicsName = listTopics.map((topic, index) => {
    if (index === arrayLength - 1) {
      return (
        <TimelineItemNew key={topic.id}>
          <TimelineSeparator>
            <TimelineDot className={classes.itemsTimeDot} />
          </TimelineSeparator>
          <TimelineContent className={classes.itemsTimeline}>
            {topic}
          </TimelineContent>
        </TimelineItemNew>
      );
    }
    return (
      <TimelineItemNew key={topic.id}>
        <TimelineSeparator>
          <TimelineDot className={classes.itemsTimeDot} />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent className={classes.itemsTimeline}>
          {topic}
        </TimelineContent>
      </TimelineItemNew>
    );
  });
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [enroller, setEnroller] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const seeFullCourses = async () => {
    setOpenBackdrop(true);
    const courseById = await GetCourseById(id);
    setTopicsByCourse(courseById.data.topics);
    setOpenBackdrop(false);
    setOpen(true);
  };

  const getAllEnroller = async () => {
    setIsLoading(true);
    const allEnroller = await GetInscription(sub, id);
    setEnroller(allEnroller.data.registered);
    setIsLoading(false);
  };

  const goToWorld = () => {
    navigate(`/map/${id}`);
    sessionStorage.setItem('noneInit', false);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const iconClose = () => (
    <HighlightOffIcon onClick={handleClose} className={classes.iconClose} />
  );
  useEffect(() => {
    getAllEnroller();
  }, []);

  return (
    <Card className={classes.card}>
      <Box>
        <Box>
          <Typography className={classes.statusCard}>Nuevo</Typography>
        </Box>
        <Box className={classes.title}>
          <Box>
            <Typography className={classes.fontTitle} variant="h5">
              {title}
            </Typography>
            <Typography className={classes.font}>Curso</Typography>
          </Box>
          <img src={courseLogo} alt="course" />
        </Box>
        <Box>
          <Typography variant="body2" className={classes.font}>
            {cardDescription}
          </Typography>
        </Box>
        <Box className={classes.info}>
          <Box className={classes.infoItems}>
            <img alt="play" className={classes.img} src={play} />
            <Typography className={classes.font}>
              {`${lessons} Lecciones`}
            </Typography>
          </Box>
          <Box className={classes.infoItems}>
            <img alt="time" className={classes.img} src={time} />
            <Typography variant="body2" className={classes.font}>
              {`${duration} horas`}
            </Typography>
          </Box>
          <Box className={classes.infoItems}>
            <img alt="kcoins" className={classes.img} src={koins} />
            <Typography variant="body2" className={classes.font}>
              {`${kcoins} Koins`}
            </Typography>
          </Box>
        </Box>
        <Box>
          <Timeline orientation="vertical" className={classes.overrides}>
            {topicsName}
          </Timeline>
        </Box>
      </Box>
      <Box className={classes.cardAction}>
        { isLoading
          ? (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Cargando...
            </Button>
          )
          : enroller ? (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={goToWorld}
            >
              Continuar curso
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={seeFullCourses}
            >
              Ver curso completo
            </Button>
          )}
      </Box>
      <Backdrop
        className={classes.backdrop}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
      >
        <Box>
          <ModalCourse
            id={id}
            titleModal={title}
            descriptionModal={description}
            themesModal={topicsByCourse}
            close={iconClose}
          />
        </Box>
      </Modal>
    </Card>
  );
}

CourseCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  topics: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  lessons: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  kcoins: PropTypes.number.isRequired,
  shortDescription: PropTypes.string.isRequired,
};

export default CourseCard;
